import PageCommon from "../PageCommon.js";
import Pqp from "../../3x1010/Pqp.js";
import Globals from "../../Globals.js";
import { SecurityAcl, SecurityAclContext, AuthCheckAcl } from "../../Security.js";
import GridWrapper from "../../su/GridWrapper.js";

export default class PageLookupGroup extends PageCommon {
  constructor() {
    super();
  }
  init($data) {
    super.init($data);
    this.data = $data;
    this.showPreloader(false);
    Pqp.trace("PageLookupList - Hello world");
    // 
    this.initList($data);

    // dispaccio un evento globale
    this.dispatchInitEvent(TheDisp.EV_PAGETHIS_INITED);
  }

  initListButton(ev) {
    // console.log(ev);
    // eventType, gridWrp, dataIndex, mcCol, dataRow
    $(".btnDelete", ev.mcCol).remove();
    if (this.aclContext.HasGrantedAcl(new AuthCheckAcl(ev.dataRow.SUid, SecurityAcl.ACL_READ))) {
      $(".btnView", ev.mcCol).on("click", this.onNavigate.bind(this, ev.dataIndex));
    } else {
      $(".btnView", ev.mcCol).remove();
    }
  }

  openDetailPage(ev) {
    try {
      // console.log(ev);
      let indexClicked = ev.indices[0];
      let data = ev.target.dataSource.data[indexClicked];
      // console.log(data);
      this.indexClicked = indexClicked
      document.location.href = "/lookup/" + data.Value.toLowerCase() + "?__pi=" + this.data.page.PageId;
    }
    catch (ex) {
    }
  }

  onNavigate(dataIndex) {
    document.location.href = "/lookup/" + this.theGrid.data[dataIndex].Value.toLowerCase() + "?__pi=" + this.data.page.PageId;
  }

  initList($data) {
    this.theGrid = new GridWrapper($(".jsList"));
    let options = {
      dataSource: {
        // data: $data.rows,
        group: [
          { field: "GroupName", order: "asc" }
        ]
      },
      rowHover: false,
      altRows: false,
      selection: {
        type: "row",
        multiple: false,
        toggle: true,
      },
        columns: [
            {
                field: "Value",
                title: "Value"
            },
        {
          field: "Label",
          title: "Name"
        },
        {
          title: "ACTION",
          width: "12.5%",
          // field: "_idx",
          columnTemplate: this.theGrid.prepareColumnTemplate($("#customActions"), this.initListButton.bind(this))
        },
        {
          field: "GroupName",
          title: "Group",
          width: "12.5%"
        }
      ],
      events: {
                //selectionChanged: this.openDetailPage.bind(this),
                dblclick: (ev) => {
              let target = $(ev.target);
              if (target.is('span')) target = target.parent();
              let index = $('.sui-row').index($(target.parent()));
              const row = $(target.parent());
              const cell = $('.sui-cell', row)[0];
              const Uid = $($('span', cell)[0]).text();
              this.openDetailPageDblClick(Uid);
                }
            },
    }
    this.theGrid.create(options, $data.rows);
    this.theGrid.init("jsList");
    this.theGrid.enableSearch($(".jsListSearch"), {
      or: [
        { path: "Label", filter: "contains", value: "" },
        { path: "GroupName", filter: "contains", value: "" },
      ]
    });
      this.theGrid.swidget.hideColumn("GroupName");
      this.theGrid.swidget.hideColumn("Value");
    return;

    /*
    let mcGrid = $(".jsList");
    mcGrid.shieldGrid({
        dataSource: {
            data: $data.rows,
            group: [
                { field: "GroupName", order: "asc" }
            ]
        },
        //
        //height: $(".content").height(),
        //scrolling: true,
        //resizing: true,
        selection: {
            type: "row",
            multiple: false,
            toggle: false
        },
        rowHover: false,
        altRows: false,
        columns: [
            {
                field: "Label",
                title: "Name"
            },
            {
                title: "ACTION",
                width: "100px",
                buttons: [
                    {
                        cls: "action-btn primary",
                        caption: '<i class="icon-eye"></i>',
                        // commandName: "nav", 
                        click: this.onGridButtonEvent.bind(this,"nav")
                    }
                ],
            },
            {
                field: "GroupName",
                title: "Group",
                width: "80px"
            },
            {
                field: "Value",
                title: ""
            },
        ]
    });
    mcGrid.swidget().hideColumn("GroupName");
    mcGrid.swidget().hideColumn("Value");
    //
    return;
    */
    }
    openDetailPageDblClick(dataIndex) {
        try {

            let datalist = this.theGrid.data;
            let data = datalist.find(el => el.Value === dataIndex);
            let args = StateManager._splitUrl(document.location.href);
            document.location.href = "/lookup/" + data.Value.toLowerCase() + "?__pi=" + this.data.page.PageId;
        }
        catch (ex) {

        }
      
    }


  /*
  onGridButtonEvent(command,rowIndex, ev) {
      // becco la seguente 
      let td = $(ev[0]).siblings("td:last");
      let uid = td.text();
      //console.log(uid);
      //var item = $("#grid").swidget().dataItem(rowIndex);
      //
      if (command == "nav") {
          document.location.href = "/lookup/" + uid.toLowerCase();
      }
  }
  */
}
